import styled from 'styled-components';
import { TypographyStyles, colours, hoverUpDeleteIcon, spacing } from '../../../stylings';
import { ProductLineItemType } from './ProductLineItemImages';

export const Container = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colours.LIGHT_GREY_2};
  border-top: 1px solid ${colours.LIGHT_GREY_2};
  display: flex;
  gap: 10px;
  max-width: 740px;
  padding: ${spacing.XXXS} 0;
`;

export const TextContainer = styled.div<{ $type: ProductLineItemType }>`
  align-items: ${({ $type }) => ($type === ProductLineItemType.MULTI_IMAGE ? 'center' : 'flex-start')};
  display: flex;
  flex-direction: ${({ $type }) => ($type === ProductLineItemType.MULTI_IMAGE ? 'row' : 'column')};
  flex-grow: 1;
  gap: ${({ $type }) => ($type === ProductLineItemType.MULTI_IMAGE ? spacing.XS : '0px')};
`;

export const Name = styled.a`
  ${TypographyStyles.Label.Large.Medium}
  color: ${colours.BLACK};
  display: block;
  text-decoration: none;
  text-transform: uppercase;
`;

export const Message = styled.span`
  ${TypographyStyles.Body.Tiny.Regular}
  display: block;
`;

export const ClearButton = styled.button`
  background: none;
  border: none;

  ${hoverUpDeleteIcon(true)}

  &.cancel-icon {
    svg {
      border-radius: 50%;
    }
  }

  & svg path {
    fill: ${colours.BLACK};
  }
`;
